module.exports = "1. Si vous utilisez un bloqueur de publicités, désactivez-le pour cette étape. Certains bloqueurs de\npublicité ont tendance à bloquer l’envoi de données vers Google Analytics.\n\n2. Les intervalles de temps peuvent prendre plus que 60 secondes, car la fonction _setInterval()_ n’est pas\ntoujours précise.\n"


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/radioConfiguration/content/radioAnalytics/fr/installationNotes.md
// module id = ./src/statsradio/modules/radioConfiguration/content/radioAnalytics/fr/installationNotes.md
// module chunks = 18